import React from 'react'
import { useTranslation } from 'lib/i18n'

import { ProductsAndClassNameProps } from '../type'

import styles from './Products.module.css'

const Products: React.FC<ProductsAndClassNameProps> = ({
  profileProducts,
  onClick,
}) => {
  const { t } = useTranslation()
  if (!profileProducts?.length) return null

  return (
    <div className={styles.products} data-cy="profilePageProducts">
      <div className={styles.productsListContainer}>
        <div className={styles.productsListTitle}>
          {t('Products.promotedProducts', {
            defaultValue: 'Promoted products',
          })}
        </div>
        <div className={styles.productsList}>
          {profileProducts.map((item) => (
            <div
              className={styles.productsTag}
              data-cy="profilePageProductsTag"
              key={item.id}
              onClick={() => onClick(item.product.id)}
              role="button"
              tabIndex={0}
            >
              {item?.product?.name || ''}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Products
